import * as React from "react";
const SvgRightArrow = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 6L16 12L10 18", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgRightArrow;
